const validation = {
  required: "This field is required.",
  usernameRequired: "Username is required.",
  passwordRequired: "Password is required.",
  emailRequired: "Email address is required.",
  emailInvalid: "Please enter a valid email address.",
  codeRequired: "Verification code is required.",
  codeLength: "Verification code must be 6 digits.",
  codeNumeric: "Verification code must contain only numbers.",
  passwordMinLength: "Password must be at least 8 characters long.",
  passwordUppercase: "Password must contain at least one uppercase letter.",
  passwordLowercase: "Password must contain at least one lowercase letter.",
  passwordNumber: "Password must contain at least one number.",
  passwordSpecialChar: "Password must contain at least one special character.",
  passwordsDoNotMatch: "Passwords do not match.",
  confirmPasswordRequired: "Please confirm your password.",
  usernameInvalid:
    "Username must be 3 to 30 characters and contain only letters, numbers, dots, underscores, or hyphens.",
  usernameStartLetter:
    "Username must start with a letter and contain only English letters, numbers, dots, underscores or hyphens.",
  textMinLength: "This field must contain at least 4 characters.",
  textMaxLength: "This field must not exceed 50 characters.",
  phoneRequired: "Phone number is required.",
  phoneInvalid: "Please enter a valid phone number.",
  phoneLeadingZero:
    "Egyptian phone numbers must start with 0 (e.g. 01012345678).",
  phoneEgyptLength: "Egyptian phone numbers must be exactly 11 digits.",
  phoneSaudiStart: "Saudi phone numbers must start with 5 (e.g. 512345678).",
  phoneSaudiLength: "Saudi phone numbers must be exactly 9 digits.",
  phoneLength:
    "Phone number must have the correct digit count for the selected country.",
  nameMaxLength: "Name must be 255 characters or fewer.",
  maxLength: "Must be 255 characters or fewer.",
  nameArabicOnly: "Name must contain Arabic letters only.",
  nameEnglishOnly: "Name must contain English letters only.",
  nameTrioRequired:
    "Name must consist of three parts (first, middle, and last name).",
};

export default validation;
